import ApolloClient from 'apollo-boost';
import { GQL_BASE_URL } from './baseUrl';

const client = new ApolloClient({
    uri: GQL_BASE_URL,
});

export const { query, mutate } = client;

export default client;
